import { get } from '..';
import { Metric } from '../../constants/Types';

export type AvailableMetrics = Partial<Record<Metric, boolean>>;

const getAvailableMetrics = async (): Promise<AvailableMetrics | null> => {
  const requestUrl = 'metrics/available-metrics';
  try {
    const response = await get(requestUrl);
    const data = await response.json();
    return data?.metrics ?? null;
  } catch (error) {
    return null;
  }
};

export default getAvailableMetrics;
